<template lang="pug">
  filters-common(
    :data='filters'
  )
</template>

<script>
import FiltersCommon from '../filter/FiltersCommon'
import GraficoIdEnum from '../../../enum/graficoId'

export default {
  name: 'AllotmentDistributionConciliation',

  components: {
    FiltersCommon
  },

  data () {
    return {
      gadget: this.$store.getters.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.DISTRIBUICAO_CONCILIACAO_LOTE),
      filters: [
        {
          name: 'agrupamentoPlano',
          options: this.$store.getters.plansDashboard.map(plan => {
            return {
              id: plan.id,
              label: plan.nome
            }
          }),
          onChange: this.setSelected('setPlanSelectedAllotmentDistributionSummary', 'agrupamentoPlano'),
          order: 1
        },
        {
          name: 'agrupamentoTipoMovimento',
          options: [
            {
              id: 'TD',
              label: this.$t('dashboard.filtro.tipo.T')
            },
            {
              id: 'MF',
              label: this.$t('dashboard.filtro.tipo.MF')
            },
            {
              id: 'MB',
              label: this.$t('dashboard.filtro.tipo.E')
            }
          ],
          onChange: this.setSelected('setTypeFilterBatchDistribution', 'agrupamentoTipoMovimento'),
          order: 2
        },
        {
          name: 'agrupamentoCategoriaPrincipal',
          options: [
            {
              id: 'TD',
              label: this.$t('dashboard.filtro.tipo.T')
            },
            ...this.$store.getters.mainCategoriesDashboard.map(mainCategory => ({
              id: mainCategory.id,
              label: `${mainCategory.number} - ${mainCategory.description}`
            }))
          ],
          onChange: this.setSelected('setMainCategorySelectedAllotmentDistributionSummary', 'agrupamentoCategoriaPrincipal'),
          order: 3
        }
      ]
    }
  },

  computed: {
    periodoDashboard () {
      return this.$store.getters.periodFilterAllotmentDistribution
    }
  },

  watch: {
    periodoDashboard: {
      handler () {
        this.setFilter('periodoResultado', this.periodoDashboard)
      },
      deep: true
    }
  },

  methods: {
    getParam (filterName) {
      return this.gadget.gadgetParam.find(param => param.nome === filterName)
    },

    setFilter (filterName, value) {
      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return
      }

      const param = this.getParam(filterName)
      if (!param) {
        return
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id
        this.$store.dispatch('loadingData')
        this.$store.dispatch('setGadgetConfig', this.gadget)
          .finally(() => {
            this.$store.dispatch('dataLoaded')
          })
      }
    },

    setSelected (eventName, filterName) {
      return result => {
        if (result && result.id) {
          this.$store.dispatch(eventName, result)
          this.setFilter(filterName, result.id)
        }
      }
    }
  },

  created () {
    for (const filter of this.filters) {
      const param = this.getParam(filter.name)
      for (const option of filter.options) {
        option.__selected = param && param.valor === option.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AllotmentDistributionConciliation.vue?2ed5e92f